/* ============================================================
   Howdy Brewer — Request a Quote drawer (v2)
   Vanilla IIFE. Exposes window.HBQuote.{open,close}.
   Required to submit: >=1 item, Name, Phone, Email, Tax choice.
   Optional: Company, message. Submit disabled until all required met.
   Submission: Klaviyo "Requested a Quote" event + Cloudflare Worker draft order
   (+ best-effort contact form). Draft-order/Klaviyo failures never block the
   customer's success screen.
   ============================================================ */
(function () {
  "use strict";

  var cfg = window.HBQuoteConfig || { rootUrl: "/", contactUrl: "/contact" };
  var QUOTE_ENDPOINT = cfg.quoteEndpoint || "https://unadvertised-deal.dylan-e43.workers.dev";
  var root, overlay, form, doneEl, searchEl, resultsEl, itemsEl, emptyEl,
      emailEl, nameEl, phoneEl, companyEl, msgEl, hpEl, submitEl, errEl, taxYes, taxNo,
      progLabelEl, statusEl, statusTextEl, statusIcEl, taxWrapEl, taxSegEl;

  /* Attribution: capture the session's first page + external referrer once,
     site-wide (this script loads on every page), so any later quote request
     can be tied back to the browsing path that produced it. */
  try {
    if (!window.sessionStorage.getItem("hb_landing")) {
      window.sessionStorage.setItem("hb_landing", location.pathname + location.search);
      window.sessionStorage.setItem("hb_entry_ref", document.referrer || "(direct)");
    }
  } catch (e) {}

  function hbAttribution() {
    var a = { referrer: document.referrer || "(direct)" };
    try {
      a.landing = window.sessionStorage.getItem("hb_landing") || "";
      a.entryRef = window.sessionStorage.getItem("hb_entry_ref") || "";
    } catch (e) {}
    try {
      var m = document.cookie.match(/(?:^|;\s*)_ga=GA\d+\.\d+\.([^;]+)/);
      if (m) a.ga4ClientId = m[1];
    } catch (e) {}
    return a;
  }

  var openSource = "manual";
  var openContext = null;

  var items = [];
  var taxExempt = false;
  var taxChosen = true;   // "No" is pre-selected by default (answered = not exempt)
  var triedSubmit = false;
  var stepEls = {}, segEls = [], fieldEls = {};
  var lastFocus = null;
  var searchTimer = null;

  function $(sel, ctx) { return (ctx || document).querySelector(sel); }

  function ready(fn) {
    if (document.readyState !== "loading") fn();
    else document.addEventListener("DOMContentLoaded", fn);
  }

  function ga(name, params) {
    if (typeof gtag !== "function") return;
    gtag("event", name, Object.assign({
      event_callback: function () {}, event_timeout: 800, transport_type: "beacon"
    }, params || {}));
  }

  /* ---------- open / close ---------- */
  function open(opts) {
    if (!root) return;
    overlay.hidden = false; root.hidden = false;
    requestAnimationFrame(function () {
      overlay.classList.add("is-open");
      root.classList.add("is-open");
    });
    document.documentElement.style.overflow = "hidden";
    lastFocus = document.activeElement;
    setTimeout(function () { (items.length ? nameEl : searchEl).focus(); }, 80);
    if (opts && opts.product) addProduct(opts.product);
    openSource = (opts && opts.source) || "manual";
    openContext = (opts && opts.context) || window.hbQuoteContext || null;
    ga("quote_open", { source: openSource });
  }

  function close() {
    if (!root) return;
    overlay.classList.remove("is-open");
    root.classList.remove("is-open");
    document.documentElement.style.overflow = "";
    setTimeout(function () { overlay.hidden = true; root.hidden = true; }, 300);
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  /* ---------- line items ---------- */
  function addProduct(p) {
    addItem({ title: p.title || p.name || "", sku: p.sku || "", url: p.url || "",
              image: p.image || "", custom: false });
  }
  function addItem(obj) {
    items.push(Object.assign({ qty: 1, note: "" }, obj));
    searchEl.value = ""; closeResults(); render();
    ga("quote_add_item", { custom: !!obj.custom });
    searchEl.focus();
  }

  function render() {
    itemsEl.innerHTML = "";
    emptyEl.style.display = items.length ? "none" : "block";
    items.forEach(function (it, i) {
      var li = document.createElement("li");
      li.className = "hb-quote-v2-item" + (it.custom ? " is-custom" : "");
      var thumb = it.image
        ? '<span class="hb-quote-v2-item-thumb"><img src="' + it.image + '" alt=""></span>'
        : '<span class="hb-quote-v2-item-thumb">' + (it.custom ? "&#9998;" : "IMG") + "</span>";
      var meta = it.custom
        ? '<span class="hb-quote-v2-item-tag">Custom request</span>'
        : (it.sku ? '<span class="hb-quote-v2-item-meta">' + esc(it.sku) + "</span>" : "");
      li.innerHTML =
        thumb +
        '<div class="hb-quote-v2-item-main">' +
          '<div class="hb-quote-v2-item-name">' + esc(it.title) + "</div>" +
          meta +
          '<textarea class="hb-quote-v2-note" rows="1" placeholder="Add a note (size, spec, etc.)">' + esc(it.note) + "</textarea>" +
        "</div>" +
        '<div style="display:flex;flex-direction:column;align-items:flex-end;gap:6px">' +
          '<button type="button" class="hb-quote-v2-x" title="Remove" aria-label="Remove item">&#128465;</button>' +
          '<div class="hb-quote-v2-qty"><button type="button" data-dec aria-label="Decrease">&minus;</button>' +
            '<input type="number" min="1" value="' + it.qty + '" aria-label="Quantity">' +
            '<button type="button" data-inc aria-label="Increase">+</button></div>' +
        "</div>";
      li.querySelector("[data-dec]").onclick = function () { it.qty = Math.max(1, it.qty - 1); render(); };
      li.querySelector("[data-inc]").onclick = function () { it.qty++; render(); };
      li.querySelector("input").onchange = function (e) { it.qty = Math.max(1, parseInt(e.target.value, 10) || 1); render(); };
      li.querySelector(".hb-quote-v2-note").oninput = function (e) { it.note = e.target.value; };
      li.querySelector(".hb-quote-v2-x").onclick = function () { items.splice(i, 1); render(); };
      itemsEl.appendChild(li);
    });
    validate();
  }

  function esc(s) {
    return String(s == null ? "" : s).replace(/[&<>"']/g, function (c) {
      return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c];
    });
  }

  /* ---------- predictive search ---------- */
  function closeResults() { resultsEl.classList.remove("is-open"); resultsEl.innerHTML = ""; }

  function doSearch(q) {
    var url = cfg.rootUrl.replace(/\/$/, "") +
      "/search/suggest.json?q=" + encodeURIComponent(q) +
      "&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last";
    fetch(url, { headers: { Accept: "application/json" } })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var prods = (data && data.resources && data.resources.results && data.resources.results.products) || [];
        renderResults(prods, q);
      })
      .catch(function () { renderResults([], q); });
  }

  function renderResults(prods, q) {
    var html = prods.map(function (p) {
      var img = p.image ? '<img src="' + p.image + '" alt="">' : "IMG";
      return '<a class="hb-quote-v2-res" data-pick=\'' +
        esc(JSON.stringify({ title: p.title, url: p.url, image: p.image || "" })) + "'>" +
        '<span class="hb-quote-v2-res-thumb">' + img + "</span>" +
        '<span><span class="hb-quote-v2-res-name">' + esc(p.title) + "</span>" +
        (p.vendor ? '<span class="hb-quote-v2-res-meta">' + esc(p.vendor) + "</span>" : "") + "</span>" +
        '<span class="hb-quote-v2-res-add">+</span></a>';
    }).join("");
    html += '<a class="hb-quote-v2-res is-custom" data-custom>' +
      '<span class="hb-quote-v2-res-thumb">&#9998;</span>' +
      '<span><span class="hb-quote-v2-res-name">Add <b>"' + esc(q) + '"</b> as a custom request</span>' +
      '<span class="hb-quote-v2-res-meta">No exact product needed. Describe it and we&rsquo;ll source it</span></span>' +
      '<span class="hb-quote-v2-res-add">+</span></a>';
    resultsEl.innerHTML = html;
    resultsEl.classList.add("is-open");
    resultsEl.querySelectorAll("[data-pick]").forEach(function (el) {
      el.onclick = function () { addItem(JSON.parse(el.getAttribute("data-pick"))); };
    });
    resultsEl.querySelector("[data-custom]").onclick = function () {
      addItem({ title: searchEl.value.trim(), custom: true });
    };
  }

  /* ---------- validation ---------- */
  function validEmail(v) { return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v); }

  function setStep(n, done) { if (stepEls[n]) stepEls[n].classList.toggle("is-complete", !!done); }

  function updateProgress(states) {
    var firstIncomplete = states.indexOf(false);
    var doneCount = states.filter(Boolean).length;
    segEls.forEach(function (seg, i) {
      seg.classList.remove("is-done", "is-active");
      if (states[i]) seg.classList.add("is-done");
      else if (i === firstIncomplete) seg.classList.add("is-active");
    });
    if (progLabelEl) progLabelEl.textContent = doneCount + " of 3 steps complete";
  }

  function updateStatus(ok, s) {
    if (!statusEl) return;
    if (ok) {
      statusEl.classList.add("is-ready");
      if (statusIcEl) statusIcEl.innerHTML = "&#10003;";
      if (statusTextEl) statusTextEl.textContent = "All set, send your request";
      return;
    }
    statusEl.classList.remove("is-ready");
    if (statusIcEl) statusIcEl.innerHTML = "&#9888;";
    var missing = [];
    if (!s.hasItems) missing.push("an item");
    if (!s.hasName)  missing.push("name");
    if (!s.hasPhone) missing.push("phone");
    if (!s.hasEmail) missing.push("email");
    if (!s.hasTax)   missing.push("tax status");
    if (statusTextEl) statusTextEl.textContent = "Still needed: " + missing.join(", ");
  }

  function setFieldErr(el, show) { if (el) el.classList.toggle("has-err", !!show); }

  function refreshErrors(s) {
    setFieldErr(fieldEls.name,  !s.hasName);
    setFieldErr(fieldEls.phone, !s.hasPhone);
    setFieldErr(fieldEls.email, !s.hasEmail);
    if (emptyEl) emptyEl.classList.toggle("is-required", !s.hasItems);
    if (taxWrapEl) taxWrapEl.classList.toggle("has-err", !s.hasTax);
    if (taxSegEl) taxSegEl.classList.toggle("is-unset", !s.hasTax);
  }

  function validate() {
    var hasItems = items.length > 0;
    var hasName  = nameEl.value.trim().length > 0;
    var hasPhone = phoneEl.value.trim().length > 0;
    var hasEmail = validEmail(emailEl.value.trim());
    var step2ok  = hasName && hasPhone && hasEmail;
    var hasTax   = taxChosen;

    setStep(1, hasItems);
    setStep(2, step2ok);
    setStep(3, hasTax);
    updateProgress([hasItems, step2ok, hasTax]);

    var ok = hasItems && step2ok && hasTax;
    submitEl.disabled = !ok;

    var s = { hasItems: hasItems, hasName: hasName, hasPhone: hasPhone, hasEmail: hasEmail, hasTax: hasTax };
    updateStatus(ok, s);
    if (triedSubmit) refreshErrors(s);
    return ok;
  }

  /* ---------- SUBMIT ----------
     PRIMARY records (both best-effort — the customer always sees success):
       1. Cloudflare Worker -> Shopify draft order (multi-item, custom lines).
       2. Klaviyo "Requested a Quote" event (drives internal alert + auto-reply).
     TERTIARY: Shopify native contact form. */
  function composeBody() {
    var lines = ["QUOTE REQUEST", ""];
    if (items.length) {
      lines.push("Items requested:");
      items.forEach(function (it) {
        var label = it.custom ? '"' + it.title + '" (custom request)'
                              : it.title + (it.sku ? " [" + it.sku + "]" : "");
        lines.push("  - " + it.qty + " x " + label + (it.note ? "  note: " + it.note : ""));
      });
    }
    lines.push("");
    lines.push("Tax exempt: " + (taxExempt ? "YES" : "No"));
    if (nameEl.value.trim())    lines.push("Name: " + nameEl.value.trim());
    if (phoneEl.value.trim())   lines.push("Phone: " + phoneEl.value.trim());
    if (companyEl.value.trim()) lines.push("Company: " + companyEl.value.trim());
    if (msgEl.value.trim())     lines.push("", "Message:", msgEl.value.trim());
    lines.push("", "Submitted from: " + window.location.href);
    var attr = hbAttribution();
    lines.push("Prev page: " + attr.referrer);
    if (attr.landing)  lines.push("Session landing: " + attr.landing);
    if (attr.entryRef) lines.push("Entry referrer: " + attr.entryRef);
    if (attr.ga4ClientId) lines.push("GA4 client ID: " + attr.ga4ClientId);
    lines.push("Opened from: " + openSource);
    if (openContext) lines.push("Context: " + JSON.stringify(openContext));
    return lines.join("\n");
  }

  function submit(e) {
    e.preventDefault();
    triedSubmit = true;
    if (!validate()) {
      if (items.length === 0) searchEl.focus();
      else if (!nameEl.value.trim()) nameEl.focus();
      else if (!phoneEl.value.trim()) phoneEl.focus();
      else if (!validEmail(emailEl.value.trim())) emailEl.focus();
      return;
    }
    if (hpEl && hpEl.value) { showDone(); return; }

    root.classList.add("is-sending");
    errEl.classList.remove("is-shown");

    var email = emailEl.value.trim();
    var attr = hbAttribution();
    var props = {
      "Items": items.map(function (it) {
        return { title: it.title, sku: it.sku || "", qty: it.qty, note: it.note || "", custom: !!it.custom };
      }),
      "Item Count": items.length,
      "Tax Exempt": taxExempt,
      "Name": nameEl.value.trim(),
      "Phone": phoneEl.value.trim(),
      "Company": companyEl.value.trim(),
      "Message": msgEl.value.trim(),
      "Source": "Quote Drawer",
      "Page": window.location.href,
      "Opened From": openSource,
      "Referrer": attr.referrer,
      "Session Landing": attr.landing || "",
      "Entry Referrer": attr.entryRef || "",
      "GA4 Client ID": attr.ga4ClientId || "",
      "Picker Context": openContext ? JSON.stringify(openContext) : ""
    };

    /* 1) Shopify draft order via the Cloudflare Worker (multi-item). Best-effort:
       fire-and-forget so a backend hiccup never costs the lead or blocks success. */
    try {
      fetch(QUOTE_ENDPOINT, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          items: items.map(function (it) {
            return { title: it.title, sku: it.sku || "", url: it.url || "", qty: it.qty, note: it.note || "", custom: !!it.custom };
          }),
          name: nameEl.value.trim(),
          email: email,
          phone: phoneEl.value.trim(),
          company: companyEl.value.trim(),
          taxExempt: taxExempt,
          message: msgEl.value.trim(),
          url: window.location.href,
          openedFrom: openSource,
          referrer: attr.referrer,
          landingPage: attr.landing || "",
          entryReferrer: attr.entryRef || "",
          ga4ClientId: attr.ga4ClientId || ""
        })
      }).catch(function () {});
    } catch (err) {}

    /* 2) Klaviyo event (drives internal alert + customer auto-reply). */
    try {
      var kl = (window.klaviyo = window.klaviyo || []);
      var idp = { "$email": email };
      if (nameEl.value.trim())    idp["$first_name"] = nameEl.value.trim();
      if (phoneEl.value.trim())   idp["$phone_number"] = phoneEl.value.trim();
      if (companyEl.value.trim()) idp["Company"] = companyEl.value.trim();
      kl.push(["identify", idp]);
      kl.push(["track", "Requested a Quote", props]);
    } catch (err) {}

    /* 3) Shopify native contact form (best effort). */
    try {
      var body = new URLSearchParams();
      body.append("form_type", "contact");
      body.append("utf8", "✓");
      body.append("contact[email]", email);
      if (nameEl.value.trim()) body.append("contact[name]", nameEl.value.trim());
      body.append("contact[body]", composeBody());
      fetch(cfg.contactUrl, {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded", Accept: "text/html" },
        body: body.toString()
      }).catch(function () {});
    } catch (err) {}

    ga("quote_submit", { items: items.length, tax_exempt: taxExempt });
    root.classList.remove("is-sending");
    showDone();
  }

  function showDone() { root.classList.add("is-done"); }

  /* ---------- PDP button (beside the volume-pricing button, howdy-pdp-v2 only) ----------
     Sibling of the volume slot inside a .hb-quote-v2-volrow wrapper, never inside the
     slot (the theme + Quotify manage the slot via a body observer; nesting there froze
     the tab in a mutation loop). Sibling placement needs no observer. */
  function currentProduct() {
    var t = document.querySelector(".hb-pdp-v2-title, .hb-pdp-v2-header h1, .hb-pdp-header h1, h1");
    var img = document.querySelector('meta[property="og:image"]');
    var sku = "";
    try { sku = (window.currentVariantData && window.currentVariantData.sku) || ""; } catch (e) {}
    return {
      title: t ? t.textContent.trim() : document.title,
      sku: sku,
      url: window.location.href.split("#")[0],
      image: img ? img.getAttribute("content") : ""
    };
  }

  function buildPdpBtn() {
    var b = document.createElement("button");
    b.type = "button";
    b.className = "hb-quote-v2-pdp-btn";
    b.setAttribute("data-hbq-pdp-btn", "");
    b.innerHTML =
      '<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" ' +
      'stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" style="margin-inline-end:7px">' +
      '<path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path><path d="M14 2v6h6"></path>' +
      '<path d="M9 13h6M9 17h4"></path></svg>Request a Quote';
    b.addEventListener("click", function () { open({ source: "pdp", product: currentProduct() }); });
    return b;
  }

  function initPdpButton() {
    var slot = document.querySelector(".hb-pdp-v2-volume-slot, [data-hb-volume-slot], .hb-pdp-volume-slot");
    if (!slot || !slot.parentNode) return false;
    if (slot.parentNode.classList && slot.parentNode.classList.contains("hb-quote-v2-volrow")) return true;
    if (document.querySelector("[data-hbq-pdp-btn]")) return true;
    var wrap = document.createElement("div");
    wrap.className = "hb-quote-v2-volrow";
    slot.parentNode.insertBefore(wrap, slot);
    wrap.appendChild(slot);
    wrap.appendChild(buildPdpBtn());
    return true;
  }

  /* ---------- focus trap ---------- */
  function trap(e) {
    if (e.key === "Escape") { close(); return; }
    if (e.key !== "Tab" || root.hidden) return;
    var f = root.querySelectorAll('a[href],button:not([disabled]),input,textarea,[tabindex]:not([tabindex="-1"])');
    f = Array.prototype.filter.call(f, function (el) { return el.offsetParent !== null; });
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  }

  /* ---------- wire up ---------- */
  ready(function () {
    root = $("[data-hbq-drawer]"); overlay = $("[data-hbq-overlay]");
    if (!root) return;
    form = $("[data-hbq-form]", root); doneEl = $("[data-hbq-done]", root);
    searchEl = $("[data-hbq-search]", root); resultsEl = $("[data-hbq-results]", root);
    itemsEl = $("[data-hbq-items]", root); emptyEl = $("[data-hbq-empty]", root);
    emailEl = $("[data-hbq-email]", root); nameEl = $("[data-hbq-name]", root);
    phoneEl = $("[data-hbq-phone]", root); companyEl = $("[data-hbq-company]", root);
    msgEl = $("[data-hbq-msg]", root); hpEl = $("[data-hbq-hp]", root);
    submitEl = $("[data-hbq-submit]", root); errEl = $("[data-hbq-err]", root);
    taxYes = $("[data-hbq-tax-yes]", root); taxNo = $("[data-hbq-tax-no]", root);
    progLabelEl = $("[data-hbq-proglabel]", root);
    statusEl = $("[data-hbq-status]", root); statusTextEl = $("[data-hbq-status-text]", root);
    statusIcEl = $("[data-hbq-status-ic]", root);
    taxWrapEl = $("[data-hbq-tax-wrap]", root); taxSegEl = $("[data-hbq-tax]", root);
    stepEls[1] = $('[data-hbq-step="1"]', root);
    stepEls[2] = $('[data-hbq-step="2"]', root);
    stepEls[3] = $('[data-hbq-step="3"]', root);
    segEls = Array.prototype.slice.call(root.querySelectorAll("[data-hbq-seg]"));
    fieldEls.name = $('[data-hbq-f="name"]', root);
    fieldEls.phone = $('[data-hbq-f="phone"]', root);
    fieldEls.email = $('[data-hbq-f="email"]', root);

    render();

    searchEl.addEventListener("input", function () {
      var q = searchEl.value.trim();
      clearTimeout(searchTimer);
      if (q.length < 2) { closeResults(); return; }
      searchTimer = setTimeout(function () { doSearch(q); }, 200);
    });
    searchEl.addEventListener("keydown", function (e) {
      if (e.key === "Enter" && searchEl.value.trim()) {
        e.preventDefault();
        var first = resultsEl.querySelector("[data-pick]");
        if (first) first.click();
        else addItem({ title: searchEl.value.trim(), custom: true });
      }
    });
    document.addEventListener("click", function (e) {
      if (root.hidden) return;
      if (!resultsEl.contains(e.target) && e.target !== searchEl) closeResults();
    });

    emailEl.addEventListener("input", validate);
    nameEl.addEventListener("input", validate);
    phoneEl.addEventListener("input", validate);

    function pickTax(val) {
      taxExempt = val; taxChosen = true;
      taxYes.classList.toggle("is-on", val);
      taxNo.classList.toggle("is-on", !val);
      if (taxSegEl) taxSegEl.classList.remove("is-unset");
      validate();
    }
    taxYes.addEventListener("click", function () { pickTax(true); });
    taxNo.addEventListener("click", function () { pickTax(false); });

    form.addEventListener("submit", submit);
    overlay.addEventListener("click", close);
    root.querySelectorAll("[data-hbq-close]").forEach(function (b) { b.addEventListener("click", close); });
    document.addEventListener("keydown", trap);

    document.addEventListener("click", function (e) {
      var t = e.target.closest('[data-open-quote],a[href="#request-quote"],a[href$="#request-quote"],a[href*="quote=open"]');
      if (t) {
        e.preventDefault();
        var ctx = window.hbQuoteContext || null;
        if (t.dataset && t.dataset.model) {
          ctx = Object.assign({}, ctx || {}, { model: t.dataset.model });
        }
        open({ source: (t.dataset && t.dataset.ga4) || "link", context: ctx });
      }
    });

    try {
      var sp = new URLSearchParams(window.location.search);
      if (window.location.hash.indexOf("request-quote") > -1 || sp.get("quote") === "open") {
        open({ source: "url" });
      }
    } catch (err) {}

    window.HBQuote = { open: open, close: close };

    if (!initPdpButton()) {
      var pn = 0, pt = setInterval(function () { if (initPdpButton() || ++pn > 15) clearInterval(pt); }, 300);
    }
  });
})();
